import React, { useState } from "react";
import line from "../../images/svg -img/Line.svg";
import Slider from "react-slick";
import YouTubeVideoModal from "../modals/YouTubeVideoModal";
import add1 from "../../images/ShowCaseImage/add1.webp";
import add2 from "../../images/ShowCaseImage/add2.webp";
import add3 from "../../images/ShowCaseImage/add3.webp";
import add4 from "../../images/ShowCaseImage/add4.webp";

const ShowcaseAdSection = () => {
  const videos = [
    {
      name: "Sharman Joshi",
      youtubeUrl:
        "https://www.youtube.com/embed/IG9EyEY0FcI?si=_azBVFfnBxW0lKNm",
      thumbnail: add1,
    },
    {
      name: "Sharman Joshi",
      youtubeUrl:
        "https://www.youtube.com/embed/9Mm6t5NU84s?si=-7_q0-93DSMF0IFp",
      thumbnail: add2,
    },
    // {
    //   name: "Alok Nath",
    //   youtubeUrl:
    //     "https://www.youtube.com/embed/_sUtswxaHkY?si=3bRm8pElW9ghQ5kV",
    //   thumbnail: add3,
    // },
    {
      name: "Anup Soni",
      youtubeUrl:
        "https://www.youtube.com/embed/19m9PyJxFJk?si=rXw2TQaT6gEIs2My",
      thumbnail: add4,
    },
  ];

  const [iframe, setIframe] = useState(false);
  const [videLink, setVideoLink] = useState("");

  const playVideo = (link) => {
    setIframe(true);
    setVideoLink(link);
  };
  const closeModal = () => {
    setIframe(false);
    setVideoLink("");
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show next-arrow"
        onClick={onClick}
        aria-label="Next"
      >
        &#10095;
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show prev-arrow"
        onClick={onClick}
        aria-label="Previous"
      >
        &#10094;
      </button>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="spot-section sectiontopgap">
      <div className="sectiontitle">
        <div className="titleunderline" data-aos="fade-right">
          <img src={line} />
        </div>
        <h1 className="showCaseText">Showcase Ads</h1>
      </div>
      <div className="container ads-section">
        <p className="showcaseTitle">सपने आपके ... शुरुवात हमारी</p>
        <div>
          <Slider {...settings} className="custom-video-slider">
            {videos.map((video, idx) => (
              <div className="video-card" key={idx}>
                <div className="video-img">
                  <img
                    src={video.thumbnail}
                    alt={video.name}
                    style={{
                      width: "100%",
                      height: "190px",
                      border: "3px solid #FFFFFF",
                      borderRadius: "40px",
                    }}
                  />
                </div>
                <div
                  className="playButton"
                  onClick={() => playVideo(video.youtubeUrl)}
                >
                  <i className="fa fa-play" aria-hidden="true"></i>
                </div>
                <div className="actorNameSection">
                  <p className="actorNameFeaturing">Featuring</p>
                  <h4 className="actorName">{video.name}</h4>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {iframe && <YouTubeVideoModal url={videLink} closeModal={closeModal} />}
    </section>
  );
};

export default ShowcaseAdSection;
